<button
  *ngIf="selectedCompanyId"
  (click)="navigateToCampaignBuilder()"
  class="m-2">
  Back to Campaign builder
</button>
<h1 class="user-quiz-title">{{ this.quizTitle }}</h1>
<div class="user-quiz-container">
  <form class="user-quiz-questions-holder">
    <div
      class="user-quiz-question-holder"
      *ngFor="let question of qasetss; let i = index">
      <label for="question{{ i }}" class="question-text"
        ><p>{{ question.question }}</p>
        <span *ngIf="question.required"> {{ '*required' | translate }}</span>
        <span *ngIf="!question.required">
          {{ '*Not required' | translate }}</span
        >
      </label>
      <div
        class="user-quiz-answer"
        *ngFor="let answer of question.answers; let j = index">
        <div
          *ngIf="
            answer.location !== 'dropdown' && question.displayStyle !== 'text'
          "
          class="user-quiz-location-answer">
          <input
            *ngIf="
              answer.location !== 'dropdown' &&
              question.displayStyle !== 'text' &&
              answer.location !== 'desc'
            "
            class="user-quiz-answer-button"
            type="{{ question.displayStyle }}"
            id="answer{{ i }}-{{ j }}"
            [value]="answer.mark"
            name="answer{{ i }}"
            (change)="
              selectedAnswers(
                quiz,
                question.question,
                i,
                answer.text,
                answer.id,
                answer.mark,
                answer.disqualifying,
                question.displayStyle,
                j,
                $event,
                answer.location
              )
            "
            required />
          <label class="user-quiz-answer-text" for="answer{{ i }}-{{ j }}">
            {{ answer.text
            }}<span *ngIf="answer.location === 'desc'">{{ '' }}</span>
          </label>
          <select
            *ngIf="answer.location === 'desc'"
            class="answer-location-select"
            [(ngModel)]="selectedLocation"
            name="selectedLocation"
            (change)="
              selectedAnswers(
                quiz,
                question.question,
                i,
                answer.text,
                answer.id,
                answer.mark,
                answer.disqualifying,
                question.displayStyle,
                j,
                $event,
                answer.location
              )
            ">
            <option value="" disabled selected>--Odaberi lokaciju--</option>
            <option
              class="answer-select-option"
              *ngFor="let dropdown of dropdowns; let k = index"
              [ngValue]="dropdown"
              [selected]="dropdown === selectedLocation">
              {{ dropdown.text }}
            </option>
          </select>
        </div>
        <div
          *ngIf="
            answer.location !== 'dropdown' && question.displayStyle === 'text'
          "
          class="answer-textarea-holder">
          <textarea
            class="answer-textarea-input"
            id="answer{{ i }}-{{ j }}"
            name="answer{{ i }}"
            maxlength="3000"
            [(ngModel)]="answer.text"
            rows="4"
            (change)="
              selectedAnswers(
                quiz,
                question.question,
                i,
                answer.text,
                answer.id,
                answer.mark,
                answer.disqualifying,
                question.displayStyle,
                j,
                $event,
                answer.location
              )
            "></textarea>
        </div>
      </div>
    </div>
  </form>
  <form class="user-quiz-contact-holder">
    <div class="contact-input-holder">
      <input
        type="text"
        class="contact-input"
        id="firstName"
        [(ngModel)]="candidate.firstName"
        name="firstName"
        [placeholder]="'name' | translate"
        required />
    </div>
    <div class="contact-input-holder">
      <input
        type="text"
        class="contact-input"
        id="lastName"
        [(ngModel)]="candidate.lastName"
        name="lastName"
        [placeholder]="'surname' | translate" />
    </div>
    <div class="contact-input-holder">
      <input
        type="text"
        class="contact-input"
        id="street"
        [(ngModel)]="candidate.street"
        name="street"
        [placeholder]="'street' | translate" />
    </div>
    <div class="contact-input-holder">
      <input
        type="text"
        class="contact-input"
        id="city"
        [(ngModel)]="candidate.city"
        name="city"
        [placeholder]="'city' | translate" />
    </div>
    <div class="contact-input-holder phone-input-row">
      <div class="country-select-wrapper">
        <div class="country-select" (click)="countryDropdownOpen = !countryDropdownOpen">
          <img [src]="'https://flagcdn.com/w20/' + selectedCountryCode.toLowerCase() + '.png'"
               width="20" height="15" alt="" class="flag-icon">
          <span>{{ selectedCountryCode }} ({{ selectedDialCode }})</span>
          <span class="dropdown-arrow">&#9662;</span>
        </div>
        <div class="country-dropdown-backdrop" *ngIf="countryDropdownOpen"
             (click)="countryDropdownOpen = false"></div>
        <div class="country-dropdown" *ngIf="countryDropdownOpen">
          <div class="country-dropdown-item"
               *ngFor="let country of countries"
               (click)="selectCountry(country)">
            <img [src]="'https://flagcdn.com/w20/' + country.code.toLowerCase() + '.png'"
                 width="20" height="15" alt="" class="flag-icon">
            <span>{{ country.code }} ({{ country.dialCode }})</span>
          </div>
        </div>
      </div>
      <input
        type="tel"
        class="contact-input phone-input"
        id="phone"
        [(ngModel)]="candidate.phone"
        name="phone"
        [placeholder]="'mobile' | translate" />
    </div>
    <div class="contact-input-holder">
      <input
        type="text"
        class="contact-input"
        id="email"
        [(ngModel)]="candidate.email"
        name="email"
        [placeholder]="'email' | translate" />
    </div>
  </form>
  <div *ngIf="quiz?.cvUploadEnabled" class="cv-upload-section">
    <p class="cv-upload-label">{{ 'Upload your CV' | translate }}
      <span class="cv-not-required">{{ '*Not required' | translate }}</span>
    </p>
    <label class="cv-dropzone" [class.cv-dropzone-active]="selectedCvFile">
      <input type="file" accept=".pdf,.doc,.docx" (change)="onCvFileSelected($event)" hidden>
      <span *ngIf="!selectedCvFile" class="cv-dropzone-text">
        <span class="cv-dropzone-icon">&#128206;</span>
        {{ 'Choose file' | translate }} (PDF, DOC, DOCX — max 5MB)
      </span>
      <span *ngIf="selectedCvFile" class="cv-dropzone-file">
        <span class="cv-dropzone-icon">&#9989;</span>
        {{ selectedCvFile.name }}
      </span>
    </label>
    <span *ngIf="cvError" class="cv-error">{{ cvError }}</span>
  </div>
  <div class="user-quiz-footer">
    <div class="user-quiz-privacy">
      <input type="checkbox" name="radio" [(ngModel)]="candidate.privola" />
      <div class="user-quiz-privacy-checkbox">
        {{ gdprAcceptance }}
        <a [href]="'/privacy-policy/' + this.quiz?.url" target="_blank">
          {{ privacyPolicyTitle }} </a
        >&nbsp;
        {{ gdprAcceptance2 }}
        <a [href]="'/terms-and-conditions/' + this.quiz?.url" target="_blank"
          >{{ termsTitle }}
        </a>
      </div>
    </div>
    <div class="button-container">
      <button class="cat-button" (click)="submitApplication(candidate)" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">{{ 'Send Application' | translate }}</span>
        <span *ngIf="isSubmitting" class="submit-spinner"></span>
      </button>
    </div>
    <div class="footer-note-container">
      <p class="footer-note">{{ safetyMessage }}</p>
    </div>
  </div>
</div>
